import { styled } from "styled-components";

import { ActionButtonItem, AddKnowledgeIcon } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { activateModal } from "domains/modal/actions";
import { iconStyle } from "domains/topicDetail/components/actionButtons/iconStyle";
import { getCanAddKnowledge } from "entities/permissions/selectors";
import { createCanEditTopicSelector } from "entities/topics/selectors";

const StyledAddKnowledgeIcon = styled(AddKnowledgeIcon)`
  ${iconStyle}
`;

type AddKnowledgeButtonProps = { topicId: string };

export const AddKnowledgeButton = ({ topicId }: AddKnowledgeButtonProps) => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const canEditTopic = useSelector(createCanEditTopicSelector(topicId));
  const canAddKnowledge = useSelector(getCanAddKnowledge);

  const openAddKnowledgeModal = () => dispatch(activateModal({ id: "AddKnowledge", params: { topicId } }));

  if (!canEditTopic || !canAddKnowledge) return null;

  return (
    <ActionButtonItem
      label={translate("app.add_knowledge.title")}
      icon={<StyledAddKnowledgeIcon />}
      onClick={openAddKnowledgeModal}
      variant="add"
    />
  );
};
